import { defineMessages } from 'react-intl';

import { Currency } from '#src/__generated__/globalTypes.ts';
import { CashCryptoToggle } from '#src/components/settings/CashCryptoToggle/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import { useUpdateRewardCurrency } from './useUpdateRewardCurrency.ts';

const messages = defineMessages({
  title: {
    defaultMessage: 'Currency of rewards',
  },
  jonumBannerTitle: {
    defaultMessage: 'Rewards will be paid in crypto',
  },
  jonumBannerMessage: {
    defaultMessage:
      'Following French regulation, your rewards must be received in crypto.',
  },
});

export const RewardCurrency = () => {
  const { currentUser } = useCurrentUserContext();
  const { updateRewardCurrency } = useUpdateRewardCurrency();
  const rewardCurrency =
    currentUser?.userSettings.rewardCurrency || Currency.ETH;

  return (
    <CashCryptoToggle
      title={messages.title}
      name="rewardCurrency"
      value={rewardCurrency}
      onUpdate={updateRewardCurrency}
      disableCashForJonum
      jonumBanner={{
        title: messages.jonumBannerTitle,
        message: messages.jonumBannerMessage,
      }}
    />
  );
};
